var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-tx-inline-svg",class:{
    'rounded': _vm.stereotype === 'rounded',
    'square': _vm.stereotype === 'square'
  },attrs:{"width":_vm.svgSize.width,"height":_vm.svgSize.height}},[_c('inline-svg',{key:_vm.svgKey,attrs:{"width":_vm.svgSize.width,"height":_vm.svgSize.height,"fill":_vm.svgFill,"background":_vm.background,"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }